import React from 'react';
import { IContact } from 'src/services/api/ServiceRequestDashboard/apiContracts';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { StagedEntry } from 'src/components/ContactsTable/EmailSelfServiceDialogue/CustomHooks/useEmailSelfServiceFormState/useEmailSelfServiceFormState';
import { useContactDisplay } from 'src/components/ContactsTable/EmailSelfServiceDialogue/CustomHooks/useContactDisplay';
import './entry-row.scss';

const ALLOW_PILL_BG: string = 'rgba(34, 197, 94, 0.15)';
const ALLOW_PILL_TEXT: string = 'rgb(21, 128, 61)';
const DISALLOW_PILL_BG: string = 'rgba(234, 88, 12, 0.15)';
const DISALLOW_PILL_TEXT: string = 'rgb(154, 52, 18)';

export type SectionVariant = 'allow' | 'disallow' | 'unchanged';

export interface EntryRowProps {
  entry: StagedEntry;
  variant: SectionVariant;
}

const EntryRow = React.memo(({ entry, variant }: EntryRowProps) => {
  const contact: IContact = entry.contact;
  const { fullName, roleLabels } = useContactDisplay(contact);

  const showStatePill: boolean = variant !== 'unchanged';
  const isAllow: boolean = variant === 'allow';
  const stateLabel: string = isAllow ? 'Allow' : 'Disallow';
  const stateBgColor: string = isAllow ? ALLOW_PILL_BG : DISALLOW_PILL_BG;
  const stateTextColor: string = isAllow ? ALLOW_PILL_TEXT : DISALLOW_PILL_TEXT;

  return (
    <div className="sc-row">
      <div className="sc-row-identity">
        <div className="sc-row-name">{fullName}</div>
        <div className="sc-row-email">{contact.email ?? '—'}</div>
      </div>

      <div className="sc-row-roles">
        {roleLabels.map((roleLabel: string) => (
          <CategoryPill key={roleLabel} text={roleLabel} size="small" />
        ))}
      </div>

      <div className="sc-row-state">
        {showStatePill && (
          <CategoryPill
            text={stateLabel}
            color={stateBgColor}
            textColor={stateTextColor}
            size="small"
          />
        )}
        {!showStatePill && <CategoryPill text="No change" size="small" />}
      </div>
    </div>
  );
});

EntryRow.displayName = 'EntryRow';

export default EntryRow;
